import { gql } from '@apollo/client';

export const GET_EXPOSURE_TRIPS = gql`
query ExposureTrips($supportedOrganisationId: Int!) {
  exposureTrips(supportedOrganisationId: $supportedOrganisationId) {
    id
    name
    date
    location
    durationDays
    description
    interestedCount
    interested {
      id
      expressedAt
      person {
        id
        name
      }
    }
  }
}`;
